import styled from "styled-components";
import { EditIcon } from "../icons/ActionIcons";
import { IconButton, Tooltip } from "@mui/material";
import PropTypes from "prop-types";
import { isMobile } from "../js/statics1";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-grow: 1;
  transition: opacity 0.3s ease-in-out;
  width: ${(props) => (props.$fullWidth ? "100%" : "auto")};
  position: relative;
  &:hover .icon-button-hover {
    opacity: 1;
    transition: opacity 0.3s ease-in-out;
  }
`;

const StyledIconButton = styled(IconButton)`
  position: ${(props) => (props.$overlapButton ? "absolute" : "relative")};
  top: 0;
  right: ${(props) => (props.$overlapButton ? "0" : "auto")};
  opacity: ${(props) => (props.$alwaysVisible ? 1 : 0)};
  border: 1px solid rgba(128, 128, 128, 0.3);
  box-shadow: 0px 4px 6px rgba(128, 128, 128, 0.3);
  background-color: rgba(128, 128, 128, 0.1);
  transition: all 0.5s ease-in-out;
  &:hover {
    background-color: rgba(128, 128, 128, 0.5);
  }
`;

export default function EditButtonHover({
  children,
  onClick = () => {},
  alwaysVisible = false,
  disabled = false,
  size = "medium",
  fullWidth = false,
  ButtonIcon = EditIcon,
  overlapButton = false,
  tooltipProps = {
    placement: "left",
    title: "",
  },

  iconButtonProps = {},
  ...props
}) {
  if (isMobile()) {
    alwaysVisible = true;
    overlapButton = false;
  }

  return (
    <Container $fullWidth={fullWidth} {...props}>
      {children}
      <StyledIconButton
        disabled={disabled}
        className="icon-button-hover"
        onClick={onClick}
        $alwaysVisible={alwaysVisible}
        $overlapButton={overlapButton}
        size={size}
        {...iconButtonProps}>
        <Tooltip disableInteractive {...tooltipProps}>
          <span>{ButtonIcon ? <ButtonIcon /> : <EditIcon />}</span>
        </Tooltip>
      </StyledIconButton>
    </Container>
  );
}

EditButtonHover.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
  alwaysVisible: PropTypes.bool,
  disabled: PropTypes.bool,
  size: PropTypes.string,
  fullWidth: PropTypes.bool,
  overlapButton: PropTypes.bool,
  tooltipProps: PropTypes.object,
  iconButtonProps: PropTypes.object,
  ButtonIcon: PropTypes.func,
};
